import { combineReducers } from 'redux';
import assignmentReport from 'store/reducers/assignmentReport/assignmentReport';
import assignmentReportFilters from 'store/reducers/assignmentReport/assignmentReportFilters';
import assignmentReportExcel from 'store/reducers/assignmentReport/assignmentReportExcel';

export default combineReducers({
  assignmentReport,
  assignmentReportFilters,
  assignmentReportExcel
});